import { useState } from 'react'
import { Icon } from 'Icon'
import Album from 'components/Album'

export default function Index() {

    const [userPlaylist, setUserPlaylist] = useState([
        {
            id: 1,
            name: 'Hang Drum Meditation Music',
            image: 'https://mosaic.scdn.co/640/ab67616d00001e0219b7070b6c010889d06d4eb3ab67616d00001e02c85ced167b37eb2d57dd789eab67616d00001e02d6288316f7485d20093c7e9aab67616d00001e02e8c36de9fd3f11cbaaf4a674'
        },
        {
            id: 2,
            name: 'Liked Songs',
            image: 'https://misc.scdn.co/liked-songs/liked-songs-640.png'
        },
        {
            id: 3,
            name: 'Reading Sountrack',
            image: 'https://i.scdn.co/image/ab67706f00000002849e8bffc67e744fdaec65f8'
        },
        {
            id: 4,
            name: 'Emre & Mert',
            image: 'https://i.scdn.co/image/ab6761610000e5eb061843e4ed942d714e9f2bf0'
        },
        {
            id: 5,
            name: 'Hans Zimmer Best Of',
            image: 'https://mosaic.scdn.co/640/ab67616d00001e025e26ee959941f78ce85ac080ab67616d00001e0268ad98a01e059cc6b7963ab3ab67616d00001e02ad2137d5ee5a7cae407dc073ab67616d00001e02bb53ecc4d4e007f8c0464753'
        },
        {
            id: 6,
            name: 'Şebnem Ferah',
            image: 'https://i.scdn.co/image/ab67616d00001e02ceeb9e99579c3cfe90fffd5f'
        },
        {
            id: 7,
            name: 'DJ Wars Songs',
            image: 'https://i.scdn.co/image/ab67616d0000b273f73bcf21ddbffcadb399d6f0'
        },
        {
            id: 8,
            name: 'bir şarkısın sen ömür boyu sürecek',
            image: 'https://i.scdn.co/image/ab67706c0000da8489ef363f71b95701c5713a93'
        }
    ])

    const [singlePlaylist, setSinglePlaylist] = useState([
        {
            id: 1,
            name: 'TheDrumAndDataBass',
            description: 'DataBass - DnB',
            cover: 'https://i.scdn.co/image/ab67656300005f1fee30de050012e6917e8352eb'
        },
        {
            id: 2,
            name: 'Relaxing Ambiances',
            description: 'Relaxing Ambiances',
            cover: 'https://i.scdn.co/image/0079a2f002ad1e63b475646e226f534702cbc3c9'
        },
        {
            id: 3,
            name: 'Speak Better English with Harry',
            description: 'Harry',
            cover: 'https://i.scdn.co/image/ab67656300005f1f7ae32a171974a062c419de00'
        },
        {
            id: 4,
            name: 'derin kesitler',
            description: 'eyen',
            cover: 'https://i.scdn.co/image/85454a11fda8960abdbdcf9f5c733afdbfc8ae13'
        },
        {
            id: 5,
            name: 'Absolutely Mental',
            description: 'Ricky Gervais & Sam Harris',
            cover: 'https://i.scdn.co/image/ab67656300005f1fbe85831f0e1c129195eb60b3'
        },
        {
            id: 6,
            name: '6 Minute English',
            description: 'BBC Radio',
            cover: 'https://i.scdn.co/image/007e5ac32a40cb7772a6e0b0f58c7ff1b4016c25'
        },
        {
            id: 7,
            name: 'Stoicism for a Better Life',
            description: 'Anderson Silver',
            cover: 'https://i.scdn.co/image/d4b6a2dbad220c5ff5f4d3e7aa4b3a79e717f608'
        },
        {
            id: 8,
            name: 'The RealLife English Podcast',
            description: 'RealLife English',
            cover: 'https://i.scdn.co/image/b126eea89639613902fd4bf07e390bf8d27d5a6b'
        }
    ])

    return (
        <>

            <div className="bg-gradient-to-b from-indigo-900 to-transparent h-80 absolute top-0 left-0 w-full z-[-1]"></div>
            
            <div className="grid gap-y-10">
                <section>
                    <h3 className="text-3xl font-bold text-white pt-6 h-11 mb-8 flex items-center">Good morning</h3>
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-5 gap-y-4 gap-x-6">
                        {userPlaylist.map((playlist, key) => (
                            <a href="#" key={key} className="bg-white group rounded overflow-hidden transition-all hover:bg-opacity-20 bg-opacity-10 flex gap-x-4 items-center">
                                <img src={playlist.image} className="h-20 w-20 object-cover shadow-spotify-shadow flex-shrink-0" />
                                <div className="font-bold mr-4 line-clamp-2">
                                    {playlist.name}
                                </div>
                                <button className="w-10 h-10 rounded-full bg-spotify-green mr-4 shadow-md flex-shrink-0 flex items-center ml-auto justify-center opacity-0 transition-all group-hover:opacity-100">
                                    <Icon src="play" size={16} />
                                </button>
                            </a>
                        ))}
                    </div>
                </section>
                <section>
                    <div className="flex justify-between items-end  mb-4">
                        <div>
                            <h3 className="text-2xl font-bold text-white h-8 flex items-center">
                                Shows to try
                            </h3>
                            <p className="text-gray-300 text-sm pt-1">
                                Podcasts we think you’ll get hooked on.
                            </p>
                        </div>
                        <a href="#" className="text-xs text-gray-300 hover:underline tracking-wider font-bold">SEE ALL</a>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-8 gap-y-4 gap-x-6">
                        {singlePlaylist.map(playlist => <Album album={playlist} options={{ play: false }} key={playlist.id} />)}
                    </div>
                </section>
                <section>
                    <div className="flex justify-between items-end  mb-4">
                        <div>
                            <h3 className="text-2xl font-bold text-white h-8 flex items-center">
                                Made For Tayfun Erbilen
                            </h3>
                            <p className="text-gray-300 text-sm pt-1">
                                Get better recommendations the more you listen.
                            </p>
                        </div>
                        <a href="#" className="text-xs text-gray-300 hover:underline tracking-wider font-bold">SEE ALL</a>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-8 gap-y-4 gap-x-6">
                        {singlePlaylist.map(playlist => <Album album={playlist} key={playlist.id} />)}
                    </div>
                </section>
                <section>
                    <div className="flex justify-between items-end  mb-4">
                        <div>
                            <h3 className="text-2xl font-bold text-white h-8 flex items-center">
                                Recently played
                            </h3>
                        </div>
                        <a href="#" className="text-xs text-gray-300 hover:underline tracking-wider font-bold">SEE ALL</a>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-8 gap-y-4 gap-x-6">
                        {singlePlaylist.map(playlist => <Album album={playlist} key={playlist.id} />)}
                    </div>
                </section>
            </div>

        </>
    )
}
